export const locale = {
  lang: 'es',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'Cargando líderes',
        'TEX_FILT_INFO':'Filtrando líderes',
        'TEX_TITL_TAB1':'Selección de líderes',
        'TEX_TITL_TAB2':'Prevista líderes seleccionados',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*Selecciona los líderes a aplicar',
        'TEX_INDIC_BUSQ':'Ingresa el nombre, correo o area',
        'TEX_BTN_FILT':'Filtrar',
        'TH_1':'Nombre líder',
        'TH_2':'Correo',
        'TH_3':'Area',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'Estatus usuario CGO',
        'TH_EMA_LOCA':'Localidad',
        'TH_EMA_SEND':'Correos enviados',
        'TH_PUEST_LEAD':'Puesto',
        'STATUS_LOGIN_CGO':{
        'false':'Inactivo',
        'true':'Activo',
        'undefined':'Inactivo',
        },
        'MODAL_ACTU_BAN_UNI':'Agregando líder seleccionado',
        'MODAL_ACTU_BAN_MUL':'Agregando líderes seleccionados',
        'WARNI_NO_SELEC':'Aún no se puede completar el paso,ya que no ha seleccionado ningún líder',
        'COMFI_COMP_PAS':'¿Está seguro de completar el paso de selección de lÍderes?',
        'BTN_CONFI_OK':'OK',
        'BTN_CONFI_YES':'Si',
        'BTN_CONFI_NO':'No',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> Para enviar los correos electrónicos de invitación, ingrese el codigo en rojo en la caja de texto ',
        'MSN_INGR_COD2':'</span>',
        'MODAL_CONFI_SEND_MAIL':'¿Está seguro de enviar los correos?',
        'MODAL_CONFI_ACTIV_USER_CGO':'¿Está seguro de activar  el usuario?',
        'MODAL_CONFI_DESACTIV_USER_CGO':'¿Está seguro de desactivar  el usuario?',
        'MSN_INGR_COD_ACTI_USER':'<span> Para activar/desactivar el usuario, ingrese el codigo en rojo en la caja de texto ',
        'MODAL_ERR_COD':'No coincide el texto colocado',
        'WARNI_NO_SELEC_LEA':'Para poder enviar correos,seleccione al menos un líder',
        'BTN_SEND_MAIL': 'Enviar correos',
        'BTN_CONFI_CONFIRMAR':'Confirmar',
        'BTN_CONFI_CANCELAR':'Cancelar',
        'MOD_INFO_SEN_EMA':'Enviando correos..',
        'SUCCE_SEN_EMA':'Se han enviado correctamente',
        'NO_LEAD_PRODUCT_ASO':'El certificar asociado para este producto no contiene usuarios lideres',
        'MOD_ACTI_USE_CGO':'Actualizando estatus de usuario',
        'SUCCE_UPDA_STA_USE':'Se ha actualizado correctamente',

      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'¿Esta seguro de completar el paso de editor de correo? ',
      'FECHAS':{
        'TITULO':'Selección de fechas',
        'BTN_TEXT':'Elegir fechas',
        'INSTRUC_TEXT':'Seleccione y registre las diferentes fechas disponibles para configurar',
      },
      'CORREOS':{
        'TITULO':'Mensajes de comunicación',
        'BTN_TEXT':'Ver mensajes de comunicación',
        'INSTRUC_TEXT':'Revise los mensajes de comunicación a enviar',
       'TIPOS_CORREO':{
         'TIPO1_INVITA':{
           'TITULO':'Mensaje de invitación',
           'DESCRIP':'Este es el mensaje enviado a los lideres el día de lanzamiento de la invitación',
         },
         'TIPO2_RECOR_NO_INI':{
           'TITULO':'Mensaje a los lideres que no han iniciando',
           'DESCRIP':'Este es el mensaje de recordatorio enviado a los lideres que aún no inician',
         },
         'TIPO3_RECOR_NO_FINA':{
           'TITULO':'Mensaje a los lideres que aún no han terminado.',
           'DESCRIP':'Este es el mensaje de recordatorio enviado a los lideres que ya han empezado su encuesta pero aún no terminan',
         },
       }
      },
      'MODAL_ACCIO':{
    'TIPO_ACCIO_FECH':{
       'TITU_TEXT1':'Seleccione cada una de las fechas disponibles para configurar',
      }
    },
    'ETIQ':{
      'tag_name':'El nombre del líder',
      'tag_codeCoupon':'El código de cupón',
      'tag_productoId':'El id de producto',
      'tag_nameCourse':'El nombre del curso',
    }
    },
    'TIP_EMAI': {
      'lanzamiento': 'Fecha de lanzamiento invitación',
      'aviso1': 'Pre-lanzamiento (Primer aviso antes del lanzamiento de la encuesta)',
      'aviso2': 'Pre-lanzamiento (Segundo aviso antes del lanzamiento de la encuesta)',
      'cierre': 'Fecha de cierre',
      'recordatorio1': 'Fecha de envio del recordatorio a los que aun no han iniciado ',
      'recordatorio2': 'Fecha de envio del recordatorio a los que no han finalizado',
    },
    'SECCION_CONFIRM':{
      'BTN_CONFIRM_ENVIO':'Confirmar envio de correos',
      'BTN_ENVIO_CONFIRM':'Se ha confirmado el envio de correos',
      'MODAL_COMPL_CONF':'¿Esta seguro de completar el paso de confirmación de envio de correos?',
      'MODAL_WARNIN_CONF':'Para completar el paso debe confirmar el envio de los correos',
    },
    'SECCI_AVANCE':{
      'CARDS':{
        'PASO_1':{
          'TITULO':'Avance',
          'DESCRIP':'Avance de lideres ',
          'BTN_1':'Ir a portal de conteos',
          'BTN_2':'',
        },
        'PASO_2':{
          'TITULO':'Recordatorio',
          'DESCRIP':'Recordatorio a lideres  que aún no ha iniciado o finalizado el proceso',
          'BTN_1':'Recordatorio',
          'BTN_2':'',
        }
      }
    },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'Nombre',
          'email':'Correo',
          'Area':'Área',
          'JobTitle':'Puesto',
          'Localidad':'Localidad',
          'NumberOfEmails':'Correos enviados',
          'Age':'Año',
          'Gneration':'Genero',
          'IdUser':'Id usuario',
          'SurveyID':'Id encuesta',
          'keyUserlogin':'Clave',
          'Pass_cgo':'Clave',
      }
    }
  }
};
